export const fr = {
  translation: {
    "Belimo Energy Valve": "Belimo Energy Valve",
    Yes: "Oui",
    No: "Non",
    "You cannot go back from this position":
      "Impossible de revenir en arrière",
    Chapters: "Chapitres",
    Start: "Démarrer",
    "Connecting to the Energy Valve":
      "Connexion à l'Energy Valve",
    "Control Source": "Origine de la commande",
    "Do you know the design flow rate?":
      "Connaissez-vous le débit de cette configuration ?",
    "Flow Control": "Commande de débit",

    "Is the building running off fixed or varying flow temperatures?":
      "Le bâtiment fonctionne-t-il avec des températures de débit fixes ou variables ?",

    "Varying flow temperatures (Delta T Manager Scaling)":
      "Températures de débit variables (mise à l'échelle avec le Delta T manager)",

    "Fixed flow temperatures (Delta T Manager)":
      "Températures de débit fixes (Delta T manager)",

    "I am not sure": "Je ne suis pas sûr(e)",
    "Delta T Manager": "Delta T manager",
    Scaling: "Mise à l'échelle",
    "Do you know the power output?":
      "Connaissez-vous la puissance en sortie ?",
    "Yes (Power Control)": "Oui (commande de puissance)",
    "No (Position Control)": "Non (commande de position)",
    "Power Control": "Commande de puissance",
    "Position Control": "Commande de position",
    "Onboard Data Analysis": "Analyse des données intégrée",

    "Did you get a clear result from the Energy Valve?":
      "L'Energy Valve vous-a-t-elle fourni des résultats clairs ?",

    "How do you want to setup your Energy Valve?":
      "Comment souhaitez-vous configurer votre Energy Valve ?",

    "Would you like to connect to the cloud?":
      "Souhaitez-vous une connectivité au cloud ?",

    "Cloud Connectivity": "Connectivité au cloud",

    "Onboard Diagnostics / Download Data":
      "Diagnostiques intégrés / Téléchargement de données",

    "Download Data": "Télécharger les données",
    "Send optimization request":
      "Envoyer une demande d'optimisation",
    End: "Fin",

    Subtitles: "Sous-titres",
    Repeat: "Répéter",
    Continue: "Continuer",
  },
};
